import { styled } from '@mui/material/styles';
import { Link } from '@mui/material';

export const StyledLink = styled(Link)`
  cursor: pointer;
`;